import {useSoftUIController} from "../../context";
import { useEffect, useState, useRef } from "react";
import {
    setForcedMinified, setLayout,
    setMiniSidenav,
    setPageNumber,
    updateConfigWidth,
    updateForcePageNumber
} from "../../store/actions/app-actions";

import {getArchivesResultById} from "../../axios-client";
import { useLocation } from "react-router-dom";
import EditorBodyComponent from "./editorBody/EditorBodyComponent";
import SnackbarNotification from "../../reusableComponents/Snackbar/SnackbarNotification";
import {
    deleteFile,
    downloadFile,
    getDigitizationResult,
    getExportedDocuments,
    scheduleDownload
} from "../../axios-client";
import {getTitleWithDate, getTitleWithoutDate, prepareDownload} from "../../utlis/generalUtils";
import DocumentDownloadSnackbar from "../../reusableComponents/Snackbar/DocumentDownloadSnackbar";
import EditorSidenav, {DRAWER_WIDTH} from "../yai4eduEditor/editorBody/EditorSidenav";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import Drawer from "@mui/material/Drawer";
import {io} from "socket.io-client";

const DigitizationEditor =  () => {
    const [controller, dispatch] = useSoftUIController();
    const {miniSidenav, pageNumber, forcePageNumber, containerWidth, configWidth} = controller;
    const [mediaPath, setMediaPath] = useState();
    const [pdfUrl, setPdfUrl] = useState();
    const containerRef = useRef();
    const [numPages, setNumPages] = useState(null);
    const [articleId, setArticleId] = useState(0);
    const [digitizationId, setDigitizationId] = useState(0);
    const [page, setPage] = useState({});
    const [digitizationDataPath, setDigitizationDataPath] = useState("");
    const [pages, setPages] = useState([]);
    const [fileName, setFileName] = useState('');
    const [isStructured, setIsStructured] = useState(false);
    const [usedOcr, setUsedOcr] = useState('');
    const [sourceLanguage, setSourceLanguage] = useState('');
    const [targetLanguage, setTargetLanguage] = useState('');
    const [translationSelected, setTranslationSelected] = useState(false);
    const [diacriticsSelected, setDiacriticsSelected] = useState(false);
    const [updatedPages, setUpdatePages] = useState([])
    const [sidenavOpen, setSidenavOpen] = useState(false);
    const [documentDetails, setDocumentDetails] = useState({
        name: "",
        pages: 0,
        docId: "",
        digitDate:""
    });

    const location = useLocation();
    const id = new URLSearchParams(location.search).get("id");

    const elementRef = useRef(null);
    const [isFullScreen, setIsFullScreen] = useState(false);

    const [notification, setNotification] = useState({show: false, snackbarMessage: '', severity: ""});
    const {role, userId} = controller;

    const [selectedDigitization, setSelectedDigitization] = useState( []);
    const initialSelectedFields = {
        "Extracted Text(WORD)": false,
        "Translated Text(WORD)": false,
        "Summary(WORD)": false,
        "Bookmarked PDF": false,
        "Audio": false,
        "XML": false,
        "EPUB": false,
        "Searchable PDF": false,
        "HOCR": false
    }
    const [selectedFields, setSelectedFields] = useState(initialSelectedFields);
    const [documents, setDocuments] = useState([]);
    const [eventNameList, setEventNameList] = useState([]);
    const key = `document_to_download_by_${role}_${userId}`

    useEffect(() => {
        fetchStoredDocuments();
    }, []);



    useEffect(() => {
        if(id) {
            getDigitizationResult(id).then((response) => {
                setSelectedDigitization(response.data.digitization_results);
            })
                .catch((error) => {
                    console.log(error);
                })
        }
    }, [id]);

    useEffect(() => {
        const baseURL = window?.appConfig?.REACT_APP_SOCKET_SERVER || process.env.REACT_APP_SOCKET_SERVER;
        const socket = io(baseURL, {
            path: "/socket.io"
        });

        eventNameList.forEach((event) => {
            socket.on(event, () => {
                setEventNameList((prevEventNames) => prevEventNames.filter((eventName) => eventName !== event));
                fetchStoredDocuments();
            });
        });

        return () => {
            eventNameList.forEach((event) => {
                socket.off(event);
            });
            socket.disconnect();
        };
    }, [eventNameList]);


    const fetchStoredDocuments = () => {
        const storedDocuments = JSON.parse(localStorage.getItem(key)) || [];
        if (storedDocuments.length > 0) {
            getExportedDocuments({ titles: storedDocuments })
                .then(res => {
                    setDocuments(res.data.documents);
                })
                .catch(e => {
                    console.error("Failed to fetch documents:", e);
                });
        }
    };

    const handleFieldChange = (field) => {
        setSelectedFields((prev) => ({
            ...prev,
            [field]: !prev[field]
        }));
    };

    const updateDocumentToDownloadList = (documentTitle) => {
        const baseTitle = documentTitle.split("_").slice(0, -1).join("_");
        const date = documentTitle.split("_").pop();
        const existingDocuments = JSON.parse(localStorage.getItem(key)) || [];
        if (selectedFields["Extracted Text(WORD)"]) {
            existingDocuments.push(`${baseTitle}_extracted_text_${date}`);
        }
        if (selectedFields["EPUB"]) {
            existingDocuments.push(`${baseTitle}_epub_${date}`);
        }
        if (selectedFields["XML"]) {
            existingDocuments.push(`${baseTitle}_xml_zip_${date}`);
        }
        if (selectedFields["HOCR"]) {
            existingDocuments.push(`${baseTitle}_hocr_zip_${date}`);
        }
        if (selectedFields["Searchable PDF"]) {
            existingDocuments.push(`${baseTitle}_searchable_${date}`);
        }
        if (selectedFields["Translated Text(WORD)"]) {
            existingDocuments.push(`${baseTitle}_translation_${date}`);
        }
        if (selectedFields["Summary(WORD)"]) {
            existingDocuments.push(`${baseTitle}_summary_${date}`);
        }
        if (selectedFields["Bookmarked PDF"]) {
            existingDocuments.push(`${baseTitle}_bookmarked_${date}`);
        }
        if (selectedFields["Audio"]) {
            existingDocuments.push(`${baseTitle}_audio_${date}`);
        }
        localStorage.setItem(key, JSON.stringify(existingDocuments));
        fetchStoredDocuments()
    }

    const handleGenerateDocument = async () => {
        let documentTitle = getTitleWithDate(documentDetails.name)
        const baseTitle = documentTitle.split("_").slice(0, -1).join("_");
        const date = documentTitle.split("_").pop();

        if (selectedFields["Extracted Text(WORD)"]) {
            await setEventNameList((prevEventNames) => [
                ...prevEventNames,
                `document_to_download_${baseTitle}_extracted_text_${date}`
            ]);
        }
        if (selectedFields["EPUB"]) {
            await setEventNameList((prevEventNames) => [
                ...prevEventNames,
                `document_to_download_${baseTitle}_epub_${date}`
            ]);
        }
        if (selectedFields["XML"]) {
            await setEventNameList((prevEventNames) => [
                ...prevEventNames,
                `document_to_download_${baseTitle}_xml_zip_${date}`
            ]);
        }
        if (selectedFields["HOCR"]) {
            await setEventNameList((prevEventNames) => [
                ...prevEventNames,
                `document_to_download_${baseTitle}_hocr_zip_${date}`
            ]);
        }
        if (selectedFields["Searchable PDF"]) {
            await setEventNameList((prevEventNames) => [
                ...prevEventNames,
                `document_to_download_${baseTitle}_searchable_${date}`
            ]);
        }
        if (selectedFields["Translated Text(WORD)"]) {
            await setEventNameList((prevEventNames) => [
                ...prevEventNames,
                `document_to_download_${baseTitle}_translation_${date}`
            ]);
        }
        if (selectedFields["Summary(WORD)"]) {
            await setEventNameList((prevEventNames) => [
                ...prevEventNames,
                `document_to_download_${baseTitle}_summary_${date}`
            ]);
        }
        if (selectedFields["Bookmarked PDF"]) {
            await setEventNameList((prevEventNames) => [
                ...prevEventNames,
                `document_to_download_${baseTitle}_bookmarked_${date}`
            ]);
        }
        if (selectedFields["Audio"]) {
            await setEventNameList((prevEventNames) => [
                ...prevEventNames,
                `document_to_download_${baseTitle}_audio_${date}`
            ]);
        }

        scheduleDownload(id, documentTitle, selectedFields).then(res => {
            updateDocumentToDownloadList(documentTitle)
        }).catch(e => {
            console.error("Failed to schedule download:", e);
        })
    };


    const handleDownload = (doc) => {

        downloadFile({ title: doc.title })
            .then((response) => {
                prepareDownload([response.data], response.data.type, getTitleWithoutDate(doc.title))
            })
            .then(() => {
                deleteDocumentFile(doc.title);
            })
            .catch((error) => {
                console.error("Error downloading document:", error);
            });
    };

    const deleteDocumentFromLocalStorage = (documentTitle) => {
        let existingDocuments = JSON.parse(localStorage.getItem(key)) || [];
        existingDocuments = existingDocuments.filter(doc => doc !== documentTitle);
        localStorage.setItem(key, JSON.stringify(existingDocuments));

        setDocuments(prevDocuments =>
            prevDocuments.filter(document => document.title !== documentTitle)
        );

    };

    const deleteDocumentFile = (documentTitle) => {

        deleteDocumentFromLocalStorage(documentTitle);
        deleteFile(documentTitle)
            .then((result) => {
            })
            .catch((error) => {
                console.error('Error deleting file:', error);
            });
    };

    const toggleSidenav = () => {
        setSidenavOpen(!sidenavOpen);
    };

    useEffect(() => {
        setLayout(dispatch, "page");
    }, []);

    const handleFullScreen = () => {
        const element = elementRef.current;
        if (!document.fullscreenElement) {
            element.requestFullscreen().then(() => setIsFullScreen(true)).catch((err) => {
                alert(`Error attempting to enable full-screen mode: ${err.message}`);
            });
        } else {
            document.exitFullscreen().then(() => setIsFullScreen(false));
        }
    };

    const updatePageNumber = (pageNumber) => {
        setPageNumber(dispatch, pageNumber);
    }

    const setForcePageNumber = (forcePageNumber) => {
        updateForcePageNumber(dispatch, forcePageNumber);
    }

    const updateWidth = (newWidth) => {
        updateConfigWidth(dispatch, newWidth);
    }


    useEffect(() => {
        setMiniSidenav(dispatch, true);
        setForcedMinified(dispatch, true);

        const params = new URLSearchParams(location.search);
        const page = params.get("page");
        const urlPageNumber = Number(page);
        setForcePageNumber(urlPageNumber);

    }, []);

    useEffect(() => {
        if (pageNumber) {
            fetchData();
        }
    }, [pageNumber]);


    const fetchData = () => {
        getArchivesResultById(id, pageNumber).then(res => {
            const path = res.data.data.article.path;
            const maxPageCount = res.data.data.article.page_count;
            setPdfUrl(path)
            let currentPage = res.data.data.article.page
            const existingPage = updatedPages.find(item => item.num === currentPage.num);
            if (existingPage?.vertices) {
                currentPage.vertices = existingPage.vertices
            }
            if (existingPage?.markdown) {
                currentPage.markdown = existingPage.markdown
            }
            if (existingPage?.translated_text) {
                currentPage.translated_text = existingPage.translated_text
            }
            if (existingPage?.html) {
                currentPage.html = existingPage.html
            }            
            setDocumentDetails({
                name: res.data.data.article.title || "Document",
                pages: maxPageCount,
                docId: res.data.data.article.id,
                digitDate: res.data.data.article.created_at || ""
            });
            setPage(currentPage);
            setPages(res.data.data.article.pages);
            setNumPages(maxPageCount);
            setMediaPath(res.data.data.article.page.image_path)
            setArticleId(res.data.data.article.id);
            setDigitizationId(res.data.data.id);
            setFileName(res.data.data.article.filename);
            setSourceLanguage(res.data.data.article.source_language);
            setIsStructured(res.data.data.is_structured)
            setUsedOcr(res.data.data.used_ocr)
            setTargetLanguage(res.data.data.target_language);
            setTranslationSelected(res.data.data.translation_selected)
            setDiacriticsSelected(res.data.data.diacritics_selected)
            setDigitizationDataPath(res.data.data.digitization_data_path);

        }).catch(error => {

            if (error?.response?.status == 404 && pageNumber != 1) {
                setForcePageNumber(1);
                const params = new URLSearchParams(location.search);
                params.set("page", 1);
                window.history.replaceState({}, '', `${location.pathname}?${params.toString()}`);
            }
        });
    }


    return (
        <div>

            <Box sx={{display: 'flex', position: 'relative'}}>
                {!sidenavOpen && (
                    <Box sx={{width: 20}}/>
                )}
                <IconButton
                    onClick={toggleSidenav}
                    sx={theme => ({
                        width: 40,
                        height: 40,
                        borderRadius: "50%",
                        position: "absolute",
                        top: theme.spacing(8),
                        left: sidenavOpen
                            ? `calc(${DRAWER_WIDTH}px - 20px)`
                            : 0,
                        zIndex: theme.zIndex.drawer + 1,
                        bgcolor: "background.paper",
                        boxShadow: 1,
                        "&:hover": {
                            bgcolor: "#f5f5f6",
                        },
                        "& .MuiSvgIcon-root": {
                            fontSize: "1.75rem",
                        },
                        transition: theme.transitions.create("left", {
                            easing: theme.transitions.easing.sharp,
                            duration: theme.transitions.duration.enteringScreen,
                        }),
                    })}
                >
                    {sidenavOpen
                        ? <ChevronLeftIcon fontSize="inherit"/>
                        : <ChevronRightIcon fontSize="inherit"/>}
                </IconButton>
                <Drawer
                    variant="temporary"
                    anchor="left"
                    open={sidenavOpen}
                    onClose={() => setSidenavOpen(false)}
                    sx={{
                        '& .MuiDrawer-paper': {
                            width: DRAWER_WIDTH,
                            boxSizing: 'border-box',
                            borderRight: '1px solid',
                            borderColor: 'divider',
                            borderRadius: 0,
                            boxShadow: 4,
                            height: '100%',
                            top: 0,
                            left: 0,
                            margin: 0,
                            padding: 0,
                            transitionProperty: 'transform, width',
                            overflowX: 'hidden',
                        },
                        '& .MuiBackdrop-root': {
                            backgroundColor: 'rgba(0, 0, 0, 0.05)'
                        }
                    }}
                    ModalProps={{
                        keepMounted: true,
                    }}
                    BackdropProps={{
                        invisible: false,
                    }}
                >
                    <Box sx={{width: DRAWER_WIDTH, height: '100%', overflow: 'hidden'}}>
                        <EditorSidenav
                            documentName={documentDetails.name}
                            scannedPages={documentDetails.pages}
                            sourceLang={sourceLanguage}
                            targetLang={targetLanguage}
                            docId={documentDetails.docId}
                            digitDate={documentDetails.digitDate}
                            docData={selectedDigitization}
                            selectedFields={selectedFields}
                            handleFieldChange={handleFieldChange}
                            onToggleDownload={handleGenerateDocument}
                        />
                    </Box>
                </Drawer>

                <div className="yai4eduEditorLayout" ref={elementRef} style={{
                    background: '#f8f9fa', marginLeft: 0,
                    width: '100%',
                    paddingLeft: sidenavOpen ? DRAWER_WIDTH : 0,
                    transition: 'padding 0.2s ease',
                    boxSizing: 'border-box'
                }}>


                <EditorBodyComponent
                    mediaPath={mediaPath}
                    pdfUrl={pdfUrl}
                    numPages={numPages}
                    forcePageNumber={forcePageNumber}
                    pageNumber={pageNumber}
                    setForcePageNumber={setForcePageNumber}
                    containerWidth={containerWidth}
                    configWidth={configWidth}
                    updateConfigWidth={updateWidth}
                    page={page}
                    pages={pages}
                    fileName={fileName}
                    sourceLanguage={sourceLanguage}
                    targetLanguage={targetLanguage}
                    handleFullScreen={handleFullScreen}
                    isFullScreen={isFullScreen}
                    articleId={articleId}
                    digitizationId={digitizationId}
                    setNotification={setNotification}
                    setPage={setPage}
                    isStructured={isStructured}
                    usedOcr={usedOcr}
                    translationSelected={translationSelected}
                    diacriticsSelected={diacriticsSelected}
                    setUpdatePages={setUpdatePages}
                    updatedPages={updatedPages}
                    fetchData={fetchData}
                    digitizationDataPath={digitizationDataPath}
                />

                </div>
            </Box>
            <SnackbarNotification
                notification={notification}
                setNotification={setNotification}
            />
            <DocumentDownloadSnackbar
                documents={documents} handleDownload={handleDownload} deleteFile={deleteDocumentFile} userId={userId}
                onClose={deleteDocumentFromLocalStorage}
            />

        </div>

    );

}
export default DigitizationEditor;